import React, { useEffect } from 'react';
import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useVisibleCategories } from '../hooks/useVisibleCateogries';
import { ButtonGrid, ButtonGridItem } from '../../../components/ButtonGrid';
import { Button } from '../../../components/Button';
import s from './Categories.scss';
import { dataHooks as categoryButtonDataHooks } from '../datahooks';
import { HelpCircle } from 'wix-ui-icons-common';
import { Divider } from '../components/Divider/Divider';
import { CategoriesHeader } from './CategoriesHeader/CategoriesHeader';
import { useSelectedCategory, useSetSelectedCategory } from '../../../store/appStore';
import { useAppNavigation } from '../../../hooks/useAppNavigation';
import { TEMPLATE_SELECTION_URL } from '../../../consts';
import { CATEGORIES, CategoryKey } from '@common/constants/categories';

export function Categories() {
  const { t } = useTranslation();
  const setCategoryValue = useSetSelectedCategory();
  const currentCategory = useSelectedCategory();
  const visibleCategories = useVisibleCategories({});
  const { navigate } = useAppNavigation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const categoryId = params.get('categoryId') as CategoryKey | null;
    if (categoryId && categoryId in CATEGORIES) {
      setCategoryValue(categoryId);
      // Allow Zustand persist middleware to write to sessionStorage before navigating
      requestAnimationFrame(() => {
        navigate(TEMPLATE_SELECTION_URL);
      });
    }
  }, [navigate, setCategoryValue]);

  const categoryItems: ButtonGridItem[] = visibleCategories.map(([key, category]) => ({
    key,
    value: key,
    label: t(category.name),
    onClick: setCategoryValue,
    icon: <category.Icon size={24} style={{ color: category.color }} />,
    dataHook: categoryButtonDataHooks.categoryButton(key),
  }));

  const handleRandomCategorySelection = (): void => {
    const randomIndex = Math.floor(Math.random() * categoryItems.length);
    const randomCategory = categoryItems[randomIndex];
    setCategoryValue(randomCategory.value);
  };

  return (
    <Box height="100%" direction="vertical" gap={4}>
      <CategoriesHeader />

      <ButtonGrid items={categoryItems} selectedValue={currentCategory} />

      <Divider />

      <Box width="100%">
        <Button
          onClick={handleRandomCategorySelection}
          label={t('DS_CATEGORY_CHOOSE_FOR_ME')}
          icon={<HelpCircle size="24" />}
          isSelected={currentCategory === 'rts.chooseForMe'}
          dataHook={categoryButtonDataHooks.categoryButton('rts.chooseForMe')}
          className={s.chooseForMe}
          align="center"
        />
      </Box>
    </Box>
  );
}
